import { authHeader, authHeaderFormData, handleResponse } from "../helpers";
export const loyalityschemeService = {
  createScheme,
  UpdateScheme,
  fetchSchemeData,
  inActiveRow,
  GetAvailableseries,
  UploadSchemeMapping,
};

function createScheme(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/CreateScheme`,
    requestOptions
  ).then(handleResponse);
}

function UpdateScheme(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/CreateScheme`,
    requestOptions
  ).then(handleResponse);
}

function fetchSchemeData(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/GetSchemes`,
    requestOptions
  ).then(handleResponse);
}

function inActiveRow(SchemeId, isActive) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/InActiveRow/${SchemeId}/${isActive}`,
    requestOptions
  ).then(handleResponse);
}
function GetAvailableseries(proddata) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(proddata),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/GetAvailableseries`,
    requestOptions
  ).then(handleResponse);
}

function UploadSchemeMapping(formData) {
  ;
  const requestOptions = {
    method: "POST",
    headers: authHeaderFormData(),
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/UploadSchemeMapping`,
    requestOptions
  ).then(handleResponse);
}
